import type { CheckboxDesignTokens } from '@primeuix/themes/types/checkbox'

export default {
  icon: {
    lg: {
      size: '1.25rem',
    },
    sm: {
      size: '0.75rem',
    },
    size: '1rem',
    color: '{form.field.color}',
    checkedColor: '{primary.contrast.color}',
    disabledColor: '{form.field.disabled.color}',
    checkedHoverColor: '{primary.contrast.color}',
  },
  root: {
    lg: {
      width: '1.75rem',
      height: '1.75rem',
    },
    sm: {
      width: '1.25rem',
      height: '1.25rem',
    },
    width: '1.5rem',
    height: '1.5rem',
    shadow: '{form.field.shadow}',
    focusRing: {
      color: '{form.field.focus.ring.color}',
      style: '{form.field.focus.ring.style}',
      width: '{form.field.focus.ring.width}',
      offset: '{form.field.focus.ring.offset}',
      shadow: '{form.field.focus.ring.shadow}',
    },
    background: '{form.field.background}',
    borderColor: '{form.field.border.color}',
    borderRadius: '{border.radius.sm}',
    filledBackground: '{form.field.filled.background}',
    focusBorderColor: '{form.field.focus.border.color}',
    hoverBorderColor: '{form.field.hover.border.color}',
    checkedBackground: '{primary.color}',
    checkedBorderColor: '{primary.color}',
    disabledBackground: '{form.field.disabled.background}',
    invalidBorderColor: '{form.field.invalid.border.color}',
    transitionDuration: '{form.field.transition.duration}',
    checkedHoverBackground: '{primary.hover.color}',
    checkedFocusBorderColor: '{primary.color}',
    checkedHoverBorderColor: '{primary.hover.color}',
    checkedDisabledBorderColor: '{form.field.border.color}',
  },
} satisfies CheckboxDesignTokens
